$(document).ready(window.HAPI_RefreshJavascriptBehaviors);